import { Inject, Injectable } from '@angular/core';
import { ApiService } from 'src/app/core/services/api.service';
import { QueryService } from 'src/app/core/services/query.service';
import { CrudService } from 'src/app/core/services/crud.service';
import { IPageEvent } from 'src/app/core/models/paginator.model';

import { Filiere } from '../filiere.model';
import { SnackbarService } from 'src/app/core/services/snackbar-psa.service';
import { FILIERE_ENDPOINT, FILIERE_QUERY_SERVICE_INSTANCE } from '../filiere.config';

@Injectable({
  providedIn: 'root'
})
export class FiliereService extends CrudService<Filiere> {

  constructor(
    @Inject(FILIERE_QUERY_SERVICE_INSTANCE) public readonly query: QueryService<Filiere>,
    public readonly apiService: ApiService,
    protected  override readonly snackbar : SnackbarService
    //@Inject(SnackbarService) protected override readonly snackbar: SnackbarService

  ) {
    super(FILIERE_ENDPOINT, apiService, snackbar);
  }
  getAll<Filiere>(parameter : IPageEvent,filter:string, searchData?:any){
    const filtro = filter.length>0 ? `&filter=${encodeURIComponent(filter)}` : ``
    const stringSearch = searchData ? `&search=${searchData}` : ``
    const sort = `&sortBy=${encodeURIComponent('createdAt:DESC')}`
    return this.apiService.get(FILIERE_ENDPOINT+"?page="+parameter.pageIndex+"&limit="+parameter.pageSize+filtro+stringSearch+sort)
  }

  getAllFiltered(parameter: IPageEvent, searchData?: any, filters?: Record<string, any>) {
          const stringSearch = searchData || '';
          let queryParams: string[] = [];
  
          const processFilter = (keyPrefix: string, value: any) => {
              if (value === null || value === undefined) return;
              if (Array.isArray(value)) {
                  const fv = `${keyPrefix}||in||${value.join(',')}`;
                  console.log(value)
                  queryParams.push(`filter=${encodeURIComponent(fv)}`);
              } else if (typeof value === 'object') {
                  Object.keys(value).forEach(k => {
                      processFilter(`${keyPrefix}.${k}`, value[k]);
                  });
              } else {
                  const fv = `${keyPrefix}||eq||${value}`;
                  queryParams.push(`filter=${encodeURIComponent(fv)}`);
              }
          };
          if (filters) {
            console.log('filters', filters)
              Object.keys(filters).forEach(key => {
                  if (key.includes('_from')) {
                      const fv = `${key.split('_from')[0]}||gte||${filters[key]}`;
                      queryParams.push(`filter=${encodeURIComponent(fv)}`);
                  } else if (key.includes('_to')) {
                      const fv = `${key.split('_to')[0]}||lte||${filters[key]}`;
                      queryParams.push(`filter=${encodeURIComponent(fv)}`);
                  } else {
                      processFilter(key, filters[key]);
                  }
              });
          }
          queryParams.push(`page=${parameter.pageIndex}`);
          queryParams.push(`limit=${parameter.pageSize}`);
          if (searchData) queryParams.push(`search=${stringSearch}`);
  
          const queryString = queryParams.length > 0 ? `?${queryParams.join('&')}` : '';
          return this.apiService.get(FILIERE_ENDPOINT + queryString);
      }

  markAsRead(id:any){
    return this.apiService.post(FILIERE_ENDPOINT, {})
  }

}
